import styled from "styled-components";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import axiosRetry from 'axios-retry';
import { Route, Routes } from 'react-router-dom';

import TestPage from "./Components/Test.js";
import NavStuff from "./Components/Nav.js";
import HomePage from "./Components/HomePage.js";

function App() {
  


  return (
    <StyledApp className="App">
      <NavStuff/>
      <Routes>
        <Route exact path='/' element={<HomePage />}/>
        <Route exact path="/aries" element={<TestPage/>} />
        <Route exact path="/taurus" element={<TestPage/>} />
        <Route exact path="/gemini" element={<TestPage/>}/>
        <Route exact path="/cancer" element={<TestPage/>}/>
        <Route exact path="/leo" element={<TestPage/>}/>
        <Route exact path="/virgo" element={<TestPage/>}/>
        <Route exact path="/libra" element={<TestPage/>}/>
        <Route exact path="/scorpio" element={<TestPage/>}/>
        <Route exact path="/sagittarius" element={<TestPage/>}/>
        <Route exact path="/capricorn" element={<TestPage/>}/>
        <Route exact path="/aquarius" element={<TestPage/>}/>
        <Route exact path="/pisces" element={<TestPage/>}/>
      </Routes>
    </StyledApp>
  );
}

export default App;

const StyledApp = styled.div `
height: auto;
width: 100%;
display: flex;
flex-direction: column;
align-items: center;

background:
      linear-gradient(217deg, rgba(0, 0, 48,.8), rgba(255,0,0,0) 70.71%),
      linear-gradient(127deg, rgba(0, 0, 105,.8), rgba(0,255,0,0) 70.71%),
      linear-gradient(336deg, rgba(66, 7, 117,.8), rgba(0,0,255,0) 70.71%);

font-size: 1.6rem;
.artwork{
height: auto;
width: 100%;
display:flex ;
justify-content: center ;
align-items: center ;
flex-direction: column;
}

img{
  max-width: 300px;
  max-height: 700px;
}
h1{
  color: #f2f4ff;
  -webkit-user-select: none; /* Safari 3.1+ */
 -moz-user-select: none; /* Firefox 2+ */
 -ms-user-select: none; /* IE 10+ */
 user-select: none; /* Standard syntax */
}
.un{
  font-size: 3.8rem;
  padding: 0%;
  font-family: 'Lato', sans-serif;
}

h2{
  font-size: 1.8rem !important;
  color: #f2f4ff;
  -webkit-user-select: none; /* Safari 3.1+ */
 -moz-user-select: none; /* Firefox 2+ */
 -ms-user-select: none; /* IE 10+ */
 user-select: none; /* Standard syntax */
}

.ii{
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 5px;
}

.star{
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 3.8rem;

}
.dep{
  font-family: 'Ubuntu Mono', monospace;
  font-size: 3.8rem;
}

`